import { Component } from '@angular/core';

@Component({
  selector: 'app-ambulance',
  standalone: true,
  imports: [],
  templateUrl: './ambulance.component.html',
  styleUrl: './ambulance.component.scss'
})
export class AmbulanceComponent {

}
